<form
  class="comment-form"
  [formGroup]="form"
  (ngSubmit)="submit()"
  [attr.aria-busy]="submitting() || null"
  novalidate
>
  <h3 class="comment-form__heading">{{ copy.formHeading }}</h3>

  @if (replyTo(); as parent) {
    <div class="comment-form__replying">
      <span>{{ copy.replyingTo(parent.authorName) }}</span>
      <button type="button" class="comment-form__link" (click)="cancelReply.emit()">
        {{ copy.cancelReply }}
      </button>
    </div>
  }

  @if (isAuthenticated() && userName()) {
    <p class="comment-form__as">{{ copy.commentingAs(userName()) }}</p>
  }

  <div class="comment-form__field">
    <label class="comment-form__label" for="blog-comment-body">{{ copy.bodyLabel }}</label>
    <textarea
      #bodyInput
      id="blog-comment-body"
      class="comment-form__control comment-form__textarea"
      formControlName="body"
      rows="5"
      [class.comment-form__control--error]="fieldError('body')"
      [attr.aria-invalid]="fieldError('body') ? 'true' : null"
      [attr.aria-describedby]="
        fieldError('body')
          ? 'blog-comment-body-counter blog-comment-body-error'
          : 'blog-comment-body-counter'
      "
      (input)="clearServerError('body')"
    ></textarea>
    <span
      id="blog-comment-body-counter"
      class="comment-form__counter"
      [class.comment-form__counter--over]="bodyOverLimit()"
      >{{ copy.bodyCounter(bodyLength(), limits.body) }}</span
    >
    @if (fieldError('body'); as message) {
      <p id="blog-comment-body-error" class="comment-form__error">{{ message }}</p>
    }
  </div>

  @if (!isAuthenticated()) {
    <div class="comment-form__row">
      <div class="comment-form__field">
        <label class="comment-form__label" for="blog-comment-name">{{ copy.nameLabel }}</label>
        <input
          id="blog-comment-name"
          class="comment-form__control"
          type="text"
          formControlName="author_name"
          autocomplete="name"
          [class.comment-form__control--error]="fieldError('author_name')"
          [attr.aria-invalid]="fieldError('author_name') ? 'true' : null"
          [attr.aria-describedby]="fieldError('author_name') ? 'blog-comment-name-error' : null"
          (input)="clearServerError('author_name')"
        />
        @if (fieldError('author_name'); as message) {
          <p id="blog-comment-name-error" class="comment-form__error">{{ message }}</p>
        }
      </div>

      <div class="comment-form__field">
        <label class="comment-form__label" for="blog-comment-email">{{ copy.emailLabel }}</label>
        <input
          id="blog-comment-email"
          class="comment-form__control"
          type="email"
          formControlName="author_email"
          autocomplete="email"
          [class.comment-form__control--error]="fieldError('author_email')"
          [attr.aria-invalid]="fieldError('author_email') ? 'true' : null"
          [attr.aria-describedby]="
            fieldError('author_email')
              ? 'blog-comment-email-hint blog-comment-email-error'
              : 'blog-comment-email-hint'
          "
          (input)="clearServerError('author_email')"
        />
        <span id="blog-comment-email-hint" class="comment-form__hint">{{ copy.emailHint }}</span>
        @if (fieldError('author_email'); as message) {
          <p id="blog-comment-email-error" class="comment-form__error">{{ message }}</p>
        }
      </div>
    </div>
  }

  <!-- Honeypot (B111): fuera del viewport, nunca display:none. -->
  <div class="comment-form__hp" aria-hidden="true">
    <!-- Sin `name`: los gestores de contraseñas rellenan `website`/`url` aunque haya autocomplete="off". -->
    <input
      type="text"
      formControlName="website"
      tabindex="-1"
      autocomplete="off"
      data-lpignore="true"
      data-1p-ignore
      data-bwignore
      data-form-type="other"
    />
  </div>

  @if (generalErrors().length > 0) {
    <div class="comment-form__alert" role="alert">
      @for (message of generalErrors(); track $index) {
        <p>{{ message }}</p>
      }
    </div>
  }

  <div class="comment-form__status" role="status">
    @if (successMessage(); as message) {
      <p class="comment-form__success">{{ message }}</p>
    }
  </div>

  <div class="comment-form__actions">
    <!-- En vuelo, `loading` pinta el spinner de la casa, oculta la etiqueta y pone aria-busy. -->
    <app-button type="submit" [loading]="submitting()" [disabled]="coolingDown()">
      {{ copy.submit }}
    </app-button>
    <p class="comment-form__note">{{ copy.moderationNote }}</p>
  </div>
</form>
